import { render, staticRenderFns } from "./variantsPanel.vue?vue&type=template&id=afb66fc0&"
import script from "./variantsPanel.vue?vue&type=script&lang=js&"
export * from "./variantsPanel.vue?vue&type=script&lang=js&"
import style0 from "./variantsPanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "variantsPanel.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VFlex,
  VLayout,
  VProgressLinear,
  VSelect,
  VSwitch,
  VTextField,
})
